export const ICON_SIZES: { [size: string]: number } = {
  xxs: 0,
  xs: 0.75,
  s: 1,
  m: 1,
  l: 1.25,
  xl: 0,
};
